import { useUserV2 } from "hooks"

export const useNMPriceLabel = (): string => {
  const { isMember } = useUserV2()

  return isMember ? "Traditional Retail" : "Non-Members"
}
